import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, CheckCircle2, Loader2 } from "lucide-react";
import { apiPublic } from "@/lib/api";

export default function CantAccess() {
    const [form, setForm] = useState({
        nome: "", cognome: "", codice_fiscale: "", data_nascita: "", email_richiesta: "", note: "",
    });
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const onChange = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); setError(null);
        try {
            await apiPublic.post("/auth/access-request", form);
            setSubmitted(true);
        } catch (err) {
            setError(err?.response?.data?.detail || "Errore nell'invio della richiesta");
        } finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen bg-[#050505] text-white p-6 lg:p-12" data-testid="cant-access-page">
            <Link to="/login" className="inline-flex items-center gap-2 text-zinc-500 text-xs uppercase tracking-widest font-grotesk hover:text-acid transition" data-testid="cant-access-back">
                <ArrowLeft className="h-4 w-4" /> Torna al login
            </Link>

            <div className="max-w-2xl mx-auto mt-12">
                {!submitted ? (
                    <>
                        <span className="label-tag">— Accesso assistito</span>
                        <h1 className="font-display text-5xl lg:text-6xl mt-3 tracking-tighter">
                            La tua email non<br />è nei nostri <span className="font-serif-italic text-acid">registri?</span>
                        </h1>
                        <p className="text-zinc-400 mt-6">Compila il modulo: il team Investor Relations verificherà la tua identità e ti contatterà entro 2 giorni lavorativi.</p>

                        <form onSubmit={onSubmit} className="mt-10 space-y-5" data-testid="cant-access-form">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                <Field label="Nome" required value={form.nome} onChange={onChange("nome")} testid="ca-nome" />
                                <Field label="Cognome" required value={form.cognome} onChange={onChange("cognome")} testid="ca-cognome" />
                                <Field label="Codice Fiscale" value={form.codice_fiscale} onChange={onChange("codice_fiscale")} testid="ca-cf" />
                                <Field label="Data di nascita" type="date" value={form.data_nascita} onChange={onChange("data_nascita")} testid="ca-dob" />
                            </div>
                            <Field label="Email che vorresti utilizzare" type="email" required value={form.email_richiesta} onChange={onChange("email_richiesta")} testid="ca-email" />
                            <div>
                                <label className="label-tag block mb-3">Note (opzionale)</label>
                                <textarea
                                    rows={4}
                                    value={form.note}
                                    onChange={onChange("note")}
                                    className="w-full bg-[#0F0F0F] border border-zinc-800 text-white p-4 font-grotesk focus:outline-none focus:border-acid transition resize-none"
                                    data-testid="ca-note"
                                    placeholder="Qualunque info utile alla verifica della tua identità"
                                />
                            </div>
                            {error && <div className="border border-magenta/40 bg-magenta/10 text-magenta px-4 py-3 text-sm" data-testid="ca-error">{error}</div>}
                            <button type="submit" disabled={loading} className="btn-rebel" data-testid="ca-submit">
                                {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Invio…</> : <>Invia richiesta <ArrowUpRight className="h-4 w-4" /></>}
                            </button>
                        </form>
                    </>
                ) : (
                    <div className="text-center py-20" data-testid="ca-success">
                        <CheckCircle2 className="h-20 w-20 text-acid mx-auto mb-8" />
                        <h2 className="font-display text-5xl tracking-tighter">Richiesta inviata.</h2>
                        <p className="text-zinc-400 mt-6 max-w-md mx-auto">Il team Investor Relations verificherà i dati e ti contatterà entro <strong className="text-white">2 giorni lavorativi</strong>.</p>
                        <Link to="/" className="btn-ghost mt-10">Torna alla home</Link>
                    </div>
                )}
            </div>
        </div>
    );
}

function Field({ label, required, type = "text", value, onChange, testid }) {
    return (
        <div>
            <label className="label-tag block mb-3">{label}{required && <span className="text-magenta ml-1">*</span>}</label>
            <input
                type={type}
                value={value}
                onChange={onChange}
                required={required}
                data-testid={testid}
                className="w-full bg-[#0F0F0F] border border-zinc-800 text-white px-4 py-3 font-grotesk focus:outline-none focus:border-acid transition"
            />
        </div>
    );
}
